"use client";

import { ArrowRight, FileText, ShieldCheck, Search, Info, MessageSquare } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Clarification() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const smallCards = [{
    icon: ShieldCheck,
    title: "Klarifikasi Resmi",
    description: "Saluran untuk memberikan klarifikasi atas pemberitaan yang dinilai tidak akurat.",
    gradient: "from-orange-500 to-orange-600"
  }, {
    icon: Search,
    title: "Cek Fakta",
    description: "Verifikasi informasi dan klaim publik berdasarkan data dan sumber terpercaya.",
    gradient: "from-orange-500 to-orange-600"
  }, {
    icon: MessageSquare,
    title: "Hak Jawab",
    description: "Hak setiap pihak untuk memberikan tanggapan atau jawaban terhadap pemberitaan.",
    gradient: "from-orange-500 to-orange-600"
  }];
  return <section data-section-id="183" id="clarificationcardsgrid" className="relative overflow-hidden bg-white py-20 sm:py-28 lg:py-32">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[500px] w-[500px] -translate-x-1/2 rounded-lg opacity-10 blur-3xl" style={{
      background: "radial-gradient(circle, #f97316 0%, transparent 70%)"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-1.5 backdrop-blur-sm">
            <Info className="h-3.5 w-3.5 text-orange-600" aria-hidden="true" />
            <span className="font-default text-xs font-medium uppercase tracking-widest text-gray-600">
              Pusat Klarifikasi
            </span>
          </div>
          <h2 className="font-default mt-6 text-4xl font-semibold tracking-tight text-black sm:text-5xl lg:text-6xl">
            Transparansi &{" "}
            <span className="bg-clip-text text-transparent" style={{
            backgroundImage: "linear-gradient(135deg, #f97316 0%, #c2410c 50%, #451a03 100%)"
          }}>
              Akurasi
            </span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-gray-700">
            ABADI.NEWS berkomitmen menjaga integritas jurnalistik melalui kanal klarifikasi, hak jawab, dan verifikasi fakta yang profesional.
          </p>
        </div>

        <div ref={gridRef} className={`mt-16 grid grid-cols-1 gap-6 transition-all duration-1000 sm:mt-20 md:grid-cols-2 lg:grid-cols-3 ${gridVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {smallCards.map((card, i) => {
          const Icon = card.icon;
          return <div key={card.title} data-index={i} className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-gray-100 bg-white p-8 shadow-sm transition-all duration-500 hover:-translate-y-1 hover:border-orange-200 hover:shadow-md">
                <div className={`pointer-events-none absolute inset-0 rounded-lg bg-gradient-to-br ${card.gradient} opacity-0 transition-opacity duration-500 group-hover:opacity-[0.03]`} aria-hidden="true" />

                <div className="relative flex flex-1 flex-col">
                  <div className="flex h-20 w-20 items-center justify-center rounded-lg bg-orange-500 shadow-lg shadow-orange-500/20">
                    <Icon className="h-10 w-10 text-white" strokeWidth={1.5} aria-hidden="true" />
                  </div>

                  <h3 className="font-default mt-8 text-xl font-bold tracking-tight text-black">
                    {card.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-gray-600">
                    {card.description}
                  </p>

                  <div className="mt-8">
                    <Button asChild variant="outline" className="group/btn border-orange-500 text-orange-600 hover:bg-orange-50 hover:text-orange-700 rounded-lg px-6">
                      <Link to="/ClarificationPage" className="flex items-center gap-2">
                        Buka
                        <ArrowRight className="size-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}